import { render, staticRenderFns } from "./TextRadioButtons.vue?vue&type=template&id=09abebda&scoped=true"
import script from "./TextRadioButtons.vue?vue&type=script&lang=js"
export * from "./TextRadioButtons.vue?vue&type=script&lang=js"
import style0 from "./TextRadioButtons.vue?vue&type=style&index=0&id=09abebda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09abebda",
  null
  
)

export default component.exports